<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-01-17 16:20:32
 * @LastEditors: sjq
 * @LastEditTime: 2025-03-26 13:55:19
 -->
<template>
  <!-- <div class="confirm-order" :class="appUser.isNative?'':'hasUser'"> -->
  <div class="confirm-order">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <template>
      <!-- Card: 学生认证 -->
      <!-- Card: 选择地址 -->
      <NoticeBar>
        <template v-if="time > 0">
          请在
          <CountDown :time="time" format="mm:ss" style="display: inline-block" />
          内完成订单支付
        </template>
        <template v-else>订单支付已超时，请联系班主任重新下单</template>
      </NoticeBar>
      <template v-if="orderDetail.orderInfo && orderDetail.orderInfo.addressInfo">
        <CardAddress :address="orderDetail.orderInfo.addressInfo"></CardAddress>
        <margin-line />
      </template>
      <!-- Card: 商品信息 兼容积分抵扣 -->
      <CardGoodList v-for="item in orderDetail.orderGoodsList" :goods="item" :key="item.goodsId" />
      <margin-line />
      <!-- Card: 优惠券 -->
      <div data-v-68c9c139="" class="card-coupons">
        <div class="card-coupons_inner">
          <div class="item-title item-lable ispay">
            实付
            <span class="reduce-price">(已省¥{{ orderDetail.orderInfo.discount }})</span>
            <div class="item-value order-amount">
              <!-- 实付总价 -->
              <template v-if="orderDetail.orderInfo.amount > 0">
                ¥
                <span>{{ orderDetail.orderInfo.amount }}</span>
              </template>
            </div>
          </div>
          <div class="card-discount-list" v-if="orderDetail.orderDiscountList.length > 0">
            <div v-for="(item, index) in orderDetail.orderDiscountList" :key="index">
              <transition name="fade" :key="index">
                <div class="discount-item">
                  <div class="item-name">{{ item.name }}</div>
                  <div class="item-value">-¥{{ item.discount }}</div>
                </div>
              </transition>
            </div>
          </div>
          <!-- 历史消费金额 -->
          <div v-if="orderDiscountList.length > 0" class="card-discount-list">
            <div class="is-discount-list item-lable">
              <div class="item-name">历史消费金额抵扣</div>
              <div class="item-value">
                <span class="discount_price_box">-¥{{ discountprice }}</span>
              </div>
            </div>
            <div v-for="(item, index) in orderDiscountList" :key="index">
              <transition name="fade" :key="index">
                <div class="discount-item" v-if="index < 0 || unfoldDiscountStatus">
                  <div class="item-value_name">{{ item.name }}</div>
                  <div class="item-value">-¥{{ item.discount }}</div>
                </div>
              </transition>
            </div>
            <div v-if="orderDiscountList.length > 0" class="unfold-discount" @click="toggelDiscount">
              <span class="unfold-text">
                {{ unfoldDiscountStatus === false ? '展开全部' : '收起' }}
              </span>
              <img
                class="icon-up"
                :class="unfoldDiscountStatus ? 'icon-up' : 'icon-down'"
                src="../../../images/payment/icon_up.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <margin-line />
    </template>
    <!-- Card: 支付方式 -->
    <div class="card-paymethod">
      <template v-if="orderDetail.install">
        <div class="item-lable">
          <div style="display: flex; align-items: center">
            <div class="paymethod-icon" :class="'icon_youlinyuefu'"></div>
            <div>
              友邻月付
              <span class="interest">(免息)</span>
            </div>
          </div>
        </div>
        <div class="item-lable">
          <div class="paystages">
            <div
              class="flexbox paystages-item activate"
              :class="{
                unmatched: orderDetail.install.unmatched
              }"
            >
              <div class="flexbox paystages_item_box">
                首付金额
                <span class="">¥{{ orderDetail.install.downPayments }}</span>
              </div>
              <div class="flexbox paystages_item_box">
                剩余总金额
                <span class="">¥{{ sub(orderDetail.orderInfo.amount, orderDetail.install.downPayments) }}</span>
              </div>
              <div class="flexbox paystages_item_box">
                分期数
                <span class="">{{ orderDetail.install.installmentNum }}期</span>
              </div>
              <div class="flexbox paystages_item_box">
                月付金额
                <span class="">¥{{ orderDetail.install.installmentAmount }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="item-name">选择支付方式</div>
      <div v-for="(item, index) in paymethods" :key="index">
        <div class="item-lable">
          <div class="paymethod-icon" :class="item.icon" :style="true ? 'opacity:1' : 'opacity:.3'"></div>
          <div>{{ item.label }}</div>
          <div class="item-value">
            <iconfont class="iconcircle-selected" />
          </div>
        </div>
      </div>
    </div>
    <div class="flexbox integral_pay_info_box">
      <!-- <div>实付</div> -->
      <!-- <div class="pay_num_box">{{ goods.creditVal }}{{ integralName }}</div> -->
    </div>
    <!--  专辑商品新增提醒文案 -->

    <!-- 登录用户 -->

    <!-- 用户信息 -->
    <CardUser :appUser="orderDetail.orderUserInfo" v-if="orderDetail.orderUserInfo"></CardUser>
    <!-- 支付按钮 -->

    <form-button-buttom text="立即支付" :type="time > 0 ? 'primary' : '#fff'" size="normal" @click="payOrder()">
      <template #label>
        <div class="pay-price">
          <span class="price-unit">¥</span>
          {{ orderDetail.install ? orderDetail.install.downPayments : orderDetail.orderInfo.amount }}
        </div>
      </template>
    </form-button-buttom>
  </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui'
import { NoticeBar, CountDown } from 'vant'
import Body from '@/mixins/body'
import CardAddress from './components/confirm-pay/card-address'
import CardUser from './components/confirm-pay/card-user'
import CardGoods from './components/card-goods'
import CardGoodList from './components/card-good-list'
import CardCoupons from './components/card-coupons'
// import CardPaymethod from './components/confirm-pay/card-paymethod'
import { orderService } from '@/api'
import { isAlipay } from '@/utils/init/wx'
import { mapGetters } from 'vuex'
import { throttle } from '@/utils'
import { Pay } from '@/utils/common/pay'
import { appUser, storage } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
import { mul, sub } from '@/utils/compute-util'

//
export default {
  name: 'ConfirmOrder',
  components: {
    CardAddress,
    CardGoods,
    CardCoupons,
    CardUser,
    CardGoodList,
    NoticeBar,
    CountDown
  },
  mixins: [Body],
  data() {
    return {
      orderSn: '',
      orderDetail: { orderGoodsList: [], orderInfo: {}, orderUserInfo: null },
      paymethods: [{ label: '微信支付', value: 1, icon: 'icon_wechatpay' }],
      paymethod: 1,
      time: '',
      timeing: null,
      orderDiscountList: [],
      unfoldDiscountStatus: false,
      sub
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode']),
    // 历史消费总计
    discountprice() {
      return this.orderDiscountList.reduce((prev, next) => {
        return prev + next.discount
      }, 0)
    }
  },
  created() {
    this.orderSn = this.$route.query.orderSn
    const wxUser = storage.AppWeixinKey().getItem()
    console.log(appUser.openId, wxUser, 'appUser')

    if (isAlipay()) {
      // 如果是在支付宝环境
      this.paymethods = [{ label: '支付宝支付', value: 2, icon: 'icon_zhifubao' }]
      this.paymethod = 2
    }
    this.getOrderDetail()
  },
  methods: {
    hasUser() {
      const wxUser = storage.AppWeixinKey().getItem()
      if (appUser.isWeixin && !wxUser.openId) {
        toLoginView({})
        return false
      }
      return true
    },
    getOrderDetail() {
      orderService
        .getOrderDetail({ orderSn: this.shareCode })
        .then(res => {
          if (res.orderInfo.addressInfo) {
            res.orderInfo.addressInfo = JSON.parse(res.orderInfo.addressInfo)
          }
          console.log(res)
          this.orderDiscountList = res.orderDiscountList.filter(item => item.type == 1)
          this.orderDetail = res
          this.orderDetail.orderGoodsList = this.orderDetail.orderGoodsList.filter(item => !item.isGift)
          this.orderDetail.orderDiscountList = res.orderDiscountList.filter(item => item.type !== 1)
          console.log(this.orderDiscountList, 'ppp')
          if (res.orderInfo) {
            let endTime = this.$moment(res.orderInfo.createTime) * 1 + 60 * 60 * 1000
            let nowTime = new Date() * 1
            this.time = endTime - nowTime > 0 ? endTime - nowTime : 0
            if (this.time > 0) {
              this.timeing = setTimeout(() => {
                this.time = 0
                clearTimeout(this.timeing)
              }, this.time)
            }
            console.log(endTime, nowTime, endTime - nowTime, '1111')
          }
        })
        .catch(err => {
          Toast({ message: err.message, position: 'middle' })
        })
    },
    payOrder: throttle(
      function () {
        if (this.time == 0) {
          Toast({ message: '订单支付已超时，请联系班主任重新下单', position: 'middle' })
          return
        }
        if (!this.hasUser()) {
          return
        }
        console.log(this.orderDetail.orderGoodsList[0].id, 'lll')
        // 调用原生购买方法
        let source = 'APP'
        if (appUser.isWeixin) source = 'PUB'
        if (appUser.isBrowser) source = 'WEB'
        let data = {
          orderSn: this.orderDetail.orderPayPlan.orderSn,
          planSn: this.orderDetail.orderPayPlan.sn,
          payCode: source,
          amount: this.orderDetail.orderPayPlan.amount,
          payType: this.paymethod == 1 ? 'WX' : 'ZFB'
        }
        if (source === 'PUB') {
          const wxUser = storage.AppWeixinKey().getItem()
          data.openId = wxUser.openId
        }
        orderService.payOrder(data).then(res => {
          Pay(res).then(result => {
            console.log(result, 'resultresult')
            let goodsId = this.orderDetail.orderGoodsList[0].id
            const toViewHash = '/confirm-pay'
            localStorage.setItem('toViewHash', toViewHash)
            res.goodsId = goodsId
            res.orderSn = this.orderDetail.orderPayPlan.orderSn
            // console.log(res, 'ressss')
            if (result != null) {
              let { status } = result
              console.log(status, 'status')
              // 查询订单需要商品ID
              this.payOrderResult(res, { status })
            }
            console.log('first1111')
          })
        })
      },
      2000,
      { leading: true }
    ),
    // 查询支付结果（用户退出没有回调，则需要特殊处理）
    payOrderResult(order, { status }) {
      console.log(status, order, '----------0000')
      if (status === 'success') {
        // 标记订单状态
        // 服务器订单状态
        this.$store.dispatch('payment/order/getPayStatusTime', order).then(data => {
          console.log('支付成功----------', data)
          const { status: payStatus } = data
          // payStatus = 1 // 测试为成功
          console.log(payStatus, '-----0000')
          if (this.successStatus(payStatus)) {
            console.log('支付结果', payStatus, 'data', data)
            this.routeSuccess(data)
          } else {
            console.log('支付失败')
            Toast({ message: '订单正在处理，请稍后查询', position: 'bottom' })
          }
        })
      } else if (status === 'cancel') {
        Toast({ message: '用户取消支付~', position: 'bottom' })
      } else {
        // 服务器订单状态
        Toast({ message: '订单支付失败~', position: 'bottom' })
      }
    },
    // 获取下单购买信息
    successStatus(status) {
      return status >= 1
    },
    failStatus(status) {
      return status === -1
    },
    // 跳转成功页面
    routeSuccess(data) {
      console.log(data, 'ppppppp')
      const goodsId = this.orderDetail.orderGoodsList[0].id
      const params = { id: goodsId }
      let name = 'success'
      console.log('准备跳转成功页面', params, this.orderDetail)
      this.$store.commit('payment/order/setPayStatus', {
        userId: this.orderDetail.orderUserInfo.id,
        ...data,
        payAnother: true
      })

      console.log('准备跳转成功页面', params)
      this.$router.replace({ name, params })
    },
    toggelDiscount() {
      this.unfoldDiscountStatus = !this.unfoldDiscountStatus
    }
  }
}
</script>

<style lang="scss">
.message-address {
  text-align: left;
}
</style>
<style lang="scss" scoped>
.tip_box {
  color: #000;
  padding: 0 0.48rem;
  .tip_name {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}

.confirm-order {
  padding-bottom: 2rem;
  // 付款按钮
  .form-bottom-button.form-bottom-label {
    background-color: #f7f9fb;
    border-top: 1px solid #eeeeee;
    .pay-price {
      font-weight: bold;
      font-size: 0.4rem;
      line-height: 0.54rem;
      color: #00b25a;
      text-align: left;
    }
    .pay-price-integral {
    }
  }
  .user_info {
    font-size: 18px;
    padding: 5px;
    text-align: left;
    overflow: hidden;
  }
}
.hasUser {
  padding-bottom: 3.2rem;
}
.integral_pay_info_box {
  justify-content: space-between;
  padding: 0.56rem 0.48rem 0;
  font-size: 0.32rem;
  font-weight: 400;
  color: #000000;
  .pay_num_box {
    font-size: 0.36rem;
    font-weight: 600;
    color: #000000;
  }
}
.card-coupons {
  text-align: left;
  background-color: #fff;
  .card-coupons_inner {
    padding: 0.48rem 0.48rem 0.24rem;
  }
  .card-order-has_coupons {
    border-bottom: 1px solid #eeeeee;
  }
  // 支付
  .ispay {
    &.item-title {
      font-size: 0.32rem;
      line-height: 0.4rem;
      color: #333333;
      padding-bottom: 0.48rem;
      // border-bottom: 1px solid #eee;
      // 已省的价格
      .reduce-price {
        margin-left: 0.08rem;
        color: #999;
      }
      // 订单支付的价格
      .order-amount {
        color: #00b25a;
        font-size: 0.28rem;
        font-weight: bold;
        span {
          font-size: 0.4rem;
        }
      }
    }
  }
  // 优惠券
  .iscoupon {
    margin-top: 0.2rem;
  }
  .card-discount-list {
    // margin-top: 0.24rem;
    border-top: 1px solid rgba(235, 235, 235, 1);
  }
  .item-name {
    font-size: 0.28rem;
    color: #000;
    padding: 0.23rem 0;
  }
  .item-lable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 0.48rem;
    font-size: 14px;
    &.iscoupon {
      margin-bottom: 0;
    }
    .item-lable-tag {
      background: #e65c53;
      color: #fff;
      padding: 0.04rem 0.08rem;
      border-radius: 0.04rem;
      display: inline-block;
      font-size: 0.2rem;
      line-height: 0.26rem;
      margin-left: 0.08rem;
    }
    .item-value_name {
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
    .item-value {
      flex: 1 1 140px;
      text-align: right;
      flex-shrink: 0;
      font-size: 0.32rem;
      .tips {
        color: #999999;
        font-size: 0.24rem;
      }
    }
  }
  .discount-item {
    display: flex;
    justify-content: space-between;
    padding: 0.23rem 0;
    color: #999;
    align-items: center;
    .item-value_name {
      font-size: 0.28rem;
    }
    .item-value {
      font-size: 0.32rem;
      color: #000000;
    }
  }
  .is-discount-list {
    padding: 0.32rem 0 0.1rem 0;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #000;
    margin-bottom: 0;
  }
  .select_value_icon {
    margin-left: 0.16rem;
    width: 0.1rem;
    height: 0.16rem;
  }
  // 展开减扣
  .unfold-discount {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0.34rem;
    .unfold-text {
      font-size: 0.24rem;
      color: #999;
    }
    .icon-up {
      width: 0.16rem;
      height: 0.16rem;
      margin-left: 0.16rem;
    }
    .icon-down {
      transform: rotate(180deg);
    }
  }
}
.card-paymethod {
  text-align: left;
  padding: 0.36rem 0.48rem;
  background-color: #fff;
  margin-bottom: 0.48rem;
  ::-webkit-scrollbar {
    display: none;
  }
  .item-name {
    color: #000;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
  // 支付方式
  .item-lable {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 0;
    font-size: 0.28rem;
    color: #000000;
    .paymethod-icon {
      width: 0.4rem;
      height: 0.4rem;
      margin-right: 0.16rem;
      &.icon_wechatpay {
        background: url('../../../images/payment/icon_wechatpay.png') round;
      }
      &.icon_youlinyuefu {
        background: url('../../../images/payment/icon_youlinyuefu.png') round;
      }
      &.icon_Alipay {
        background: url('../../../images/payment/icon_wechatpay.png') round;
      }
      &.icon_zhifubao {
        background: url('../../../images/payment/icon_zhifubao.png') round;
      }
    }
    .open {
      width: 0.84rem;
      height: 0.48rem;
      background: url('../../../images/icon/icon_open.png') round;
    }
    .close {
      width: 0.84rem;
      height: 0.48rem;
      background: url('../../../images/icon/icon_close.png') round;
    }
    .item-value {
      flex: 1;
      text-align: right;
      font-size: 0.32rem;
      .iconcircle {
        font-size: 0.4rem;
        opacity: 0.4;
      }
      .iconcircle-selected {
        font-size: 0.4rem;
        color: #00b25a;
      }
    }
  }
  .interest {
    font-size: 0.28rem;
    font-weight: 400;
    color: #999;
  }
  // 分期
  .paystages {
    width: 100%;
    margin-bottom: 0.3rem;
    .paystages-item {
      flex-shrink: 0;
      font-size: 0.24rem;
      color: #666666;
      border-radius: 0.08rem;
      border: solid 1px #dddddd;
      background-color: #ffffff;
      padding: 0.22rem 0;
      margin-bottom: 5px;
      &.activate {
        border-color: #00b25a;
        background-color: #f0f7f7;
        color: #00b25a;
      }
      &.unmatched {
        border-color: #eeeeee;
        background-color: #f7f9ff;
      }
      .paystages_item_box {
        flex-direction: column;
        flex: 1;
        border-right: 1px solid #ececec;
        font-size: 0.24rem;
        &:last-child {
          border: none;
        }
        span {
          display: block;
          margin-top: 3px;
          font-size: 0.28rem;
          font-weight: 600;
          color: #00b25a;
        }
      }
    }
  }
}
</style>
